var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseDk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6352 22.0071L40.3289 17.6249V4.25901C40.3289 3.60167 39.7907 3.05389 39.1447 3.05389H33.0084C32.3624 3.05389 31.8242 3.60167 31.8242 4.25901V8.96993L23.3732 0.369753C22.8888 -0.123251 22.1352 -0.123251 21.6507 0.369753L0.388756 22.0071C-0.41866 22.774 0.119617 24.0887 1.19617 24.0887H5.44856V44.7401C5.44856 45.3974 5.98684 46 6.6866 46H38.3911C39.0371 46 39.6292 45.4522 39.6292 44.7401V24.0887H43.8277C44.9043 24.0887 45.3888 22.774 44.6352 22.0071ZM30.5861 30.4978H24.1268V23.9244H30.5861V30.4978ZM20.8971 23.9244V30.4978H14.4378V23.9244H20.8971ZM14.4378 33.7845H20.8971V40.3578H14.4378V33.7845ZM24.1268 40.3578V33.7845H30.5861V40.3578H24.1268Z",
    fill: "#004282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseDk);
export default __webpack_public_path__ + "static/media/house-dk.6ef375e607f2c69376f9df1f7f78ed47.svg";
export { ForwardRef as ReactComponent };